import * as yup from 'yup'
import css from './pages.module.css'
import { FileUploader } from '../components/FileUploader'
import { maxLength2000Message } from '../strings/messages'
// We won't use stringYupOptional/stringYupRequired here; we replicate the same checks as narrativePage.

// --- Normalization: same as on narrative page ---
/**
 * Normalize various Unicode apostrophes and quotation marks to ASCII.
 * - Apostrophes → '
 * - Quotes → "
 * @param {string} [input]
 * @returns {string}
 */
const normalizeQuotes = input => {
  if (!input) return ''
  return (
    input
      // Apostrophes / single quotes variants → '
      .replace(
        /[\u2018\u2019\u201A\u201B\u2032\u2035\u275B\u275C\uFF07\u02BC\u00B4\u02BB\u0091\u0092]/g,
        "'"
      )
      // Double quotes variants → "
      .replace(
        /[\u201C\u201D\u201E\u201F\u2033\u2036\u275D\u275E\uFF02\u0093\u0094]/g,
        '"'
      )
      // If you want, you can also normalize backticks to apostrophes:
      .replace(/[`]/g, "'")
  )
}

// --- Reusable ASCII-only validator, with required/optional toggle ---
/**
 * Builds a Yup string validator that:
 * 1) Normalizes quotes to ASCII via transform,
 * 2) Applies required/optional,
 * 3) Enforces max length,
 * 4) Enforces ASCII-only regex.
 *
 * @param {boolean} isRequired
 * @param {number} maxLength
 * @param {string} lengthMessage
 */
const makeAsciiNormalizedValidator = (isRequired, maxLength, lengthMessage) => {
  let schema = yup
    .string()
    .transform(val => normalizeQuotes(val))
    .max(maxLength, lengthMessage)
    .test(
      'no-emojis',
      'Special characters and emojis are not allowed.',
      value => /^[\x09\x0A\x0D\x20-\x7F]*$/.test(value || '')
    )

  // Apply required or allow empty
  schema = isRequired
    ? schema.required('This field is required.')
    : schema.notRequired()

  return schema
}

export const fileUploadPage = (propOverrides = {}) => {
  const props = {
    pageId: 'file_upload_page',
    fieldName: 'evidence_description',
    required: false,
    maxLength: 2000,
    displayCharsRemaining: true,
    lengthMessage: maxLength2000Message,
    rows: 8,
    label: '',
    hint:
      'If you are unable to attach the files at this time, please include a list of any evidence you may have to support your allegation below.',
    labelClassName: css.largeLabel,
    fieldClassName: css.padTop,
    ...propOverrides
  }

  return {
    id: props.pageId,
    title: 'Helpful documents',
    validation: yup.object().shape({
      [props.fieldName]: makeAsciiNormalizedValidator(
        props.required,
        props.maxLength,
        props.lengthMessage
      )
    }),
    fields: [
      {
        name: 'documents',
        type: 'file',
        fieldClassName: props.fieldClassName,
        label: '',
        hint:
          'Please attach supporting documentation here. This may include billing statements, e-mail messages, text messages, photographs, court orders or other documentation.',
        component: FileUploader
      },
      {
        type: 'text',
        name: props.fieldName,
        label: props.label,
        labelClassName: props.labelClassName,
        hint: props.hint,
        multiline: true,
        rows: props.rows,
        maxLength: props.maxLength,
        displayCharsRemaining: props.displayCharsRemaining
      }
    ]
  }
}
